import { ChangeEvent, useRef, useEffect } from "react";
import MainHeaderStore from "../../../../stores/MainHeaderStore";

interface Props {
  mainHeaderStore: MainHeaderStore;
}

const useMainHeaderSearch = ({ mainHeaderStore }: Props) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    mainHeaderStore.setSearchString(e.target.value);
  };
  const handleFocus = () => {
    if (mainHeaderStore.searchString.length) {
      mainHeaderStore.setIsSearchResultOpen(true);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        mainHeaderStore.setIsSearchResultOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    // Очистка при размонтировании компонента
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [mainHeaderStore]);

  const clear = () => {
    mainHeaderStore.setSearchString("");
  };
  return { handleOnChange, handleFocus, wrapperRef, clear };
};

export default useMainHeaderSearch;
